import { NgComponentOutlet } from '@angular/common';
import { Component, inject, InputSignal, input, ChangeDetectionStrategy } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { CMS_COMPONENT_TYPE, ContentConfig } from '@libs/cms/models';

@Component({
  selector: 'ui-cms-outlet',
  imports: [NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './cms-outlet.component.html',
})
export class CmsOutletComponent {
  public readonly config: InputSignal<ContentConfig> = input.required<ContentConfig>();
  protected readonly componentType: ComponentType<unknown> | null = inject(CMS_COMPONENT_TYPE, { optional: true });
}
